module.exports = __webpack_public_path__ + "static/media/dell-technologies.43fe1ccd.png";